import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import shareImg from '../images/shareIcon.svg';
import blackHeart from '../images/blackHeartIcon.svg';

function FavoriteDrinkCard(props) {
  const { recipe, index, favoriteRecipes, setFavoriteRecipes } = props;
  const { id, name, image, alcoholicOrNot } = recipe;
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    const time = 2500;
    navigator.clipboard.writeText(`http://localhost:3000/drinks/${id}`);
    setCopied(true);
    setTimeout(() => setCopied(false), time);
  };

  const handleUnfavorite = () => {
    const newFavorites = [...favoriteRecipes];
    newFavorites.splice(favoriteRecipes.indexOf(recipe), 1);
    localStorage.setItem('favoriteRecipes', JSON.stringify(newFavorites));
    setFavoriteRecipes(newFavorites);
  };

  return (
    <div className="f-recipe-card">
      <Link to={ `/drinks/${id}` }>
        <img
          data-testid={ `${index}-horizontal-image` }
          alt={ name }
          className="f-recipe-img"
          src={ image }
        />
      </Link>
      <div className="f-recipe-details">
        <h3 data-testid={ `${index}-horizontal-top-text` } className="f-infos">
          { alcoholicOrNot ? 'Alcoholic' : 'Not alcoholic' }
        </h3>
        <Link to={ `/drinks/${id}` }>
          <h1 data-testid={ `${index}-horizontal-name` } className="f-recipe-title">
            {name}
          </h1>
        </Link>
        <div className="f-details-buttons">
          <button
            type="button"
            data-testid={ `${index}-horizontal-share-btn` }
            className="f-share-btn"
            src={ shareImg }
            onClick={ handleClick }
          >
            <img src={ shareImg } alt="share" />
          </button>
          <button
            type="button"
            onClick={ handleUnfavorite }
            className="f-favorite-btn"
            data-testid={ `${index}-horizontal-favorite-btn` }
            src={ blackHeart }
          >
            <img src={ blackHeart } alt="unfavorite" />
          </button>
        </div>
        {
          copied && <p className="f-copied">Link copied!</p>
        }
      </div>
    </div>
  );
}

FavoriteDrinkCard.propTypes = {
  recipe: PropTypes.object,
  index: PropTypes.string,
  favoriteRecipes: PropTypes.array,
  setFavoriteRecipes: PropTypes.func,
}.isRequired;

export default FavoriteDrinkCard;
